import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { useStore } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Checkbox, FormProvider } from '~/shared/ui/form'
import { Modal } from '~/shared/ui/Modal'
import {
  $inspectionId,
  sentToSecurity,
  sentToSecurityFx,
  closeSafetyInspectionModal,
  goToInspectionsFx,
} from './model'
import { Title, Description } from './styled'

export function SafetyInspection() {
  const { t } = useTranslation()

  const inspectionId = useStore($inspectionId)
  const isSentToSecurityPending = useStore(sentToSecurityFx.pending)

  const form = useForm<{ isDriverWasSentToSecurity: boolean }>()

  const handleSentToSecurity = () => {
    const isDriverWasSentToSecurity = form.getValues(
      'isDriverWasSentToSecurity',
    )

    if (isDriverWasSentToSecurity) {
      sentToSecurity()
    } else {
      closeSafetyInspectionModal()
      goToInspectionsFx()
    }
  }

  return (
    <Modal
      isShow={Boolean(inspectionId)}
      onOk={handleSentToSecurity}
      ok={t('button.confirm')}
      canBackdropClose={false}
      isLoading={isSentToSecurityPending}
    >
      <Title>{t('security department')}</Title>

      <IonChip color='danger' style={{ marginBottom: '16px' }}>
        <IonIcon icon={bulb}></IonIcon>
        <IonLabel>
          {t(
            'attention! the driver must be sent to the security department for further investigation.',
          )}
        </IonLabel>
      </IonChip>

      <Description>
        {t(
          'please make sure the driver is informed and follows the established instructions.',
        )}
      </Description>

      <FormProvider form={form}>
        <Checkbox
          labelI18n='form.driver sent to security'
          name='isDriverWasSentToSecurity'
          style={{ margin: '12px 0' }}
        />
      </FormProvider>
    </Modal>
  )
}
